import { createContext } from 'react';

import type { Entity, InspectorActions } from '../../types/entities.types';

export type DatasetInspectorContextState = {
  entities: Entity[];
  hasMore: boolean;
  hasMoreTop: boolean;
  isFilterDirty: boolean;
  loadingMore: boolean;
  loadingMoreTop: boolean;
  populating: boolean;
  freetextProgress: number;
  showingFreetextResults: boolean;
  showingIdResults: boolean;
};

export type DatasetInspectorContextArgs = {
  state?: DatasetInspectorContextState;
  actions?: InspectorActions;
  showTableView?: boolean;
  currentDatasetId?: string;
  entitiesLiveUpdated?: boolean;
  isLiveUpdatesEnabled?: boolean;
};

export const DatasetInspectorContext = createContext<DatasetInspectorContextArgs>({});
